"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactTable = require("@tanstack/react-table");
var _react = _interopRequireDefault(require("react"));
var _BaseColumn = require("./support/BaseColumn");
var ColumnGroup = function ColumnGroup(_) {
  return null;
};
var columnHelper = (0, _reactTable.createColumnHelper)();
ColumnGroup.toColumnDef = function (child, intl) {
  var _child$props = child.props,
    header = _child$props.header,
    children = _child$props.children,
    dataCy = _child$props['data-cy'];
  return columnHelper.group({
    id: header,
    header: (0, _BaseColumn.defaultHeader)(child.props),
    meta: {
      header: header,
      dataCy: dataCy
    },
    columns: _react.default.Children.map(children, function (columnChild) {
      return columnChild.type.toColumnDef(columnChild, intl);
    })
  });
};
var _default = exports.default = ColumnGroup;